import { component, OnInit, prop } from '@gbds/core/src/ts/core'

/**
 * @noInheritDoc
 */
@component('gb-regional-price')
export class RegionalPrice extends HTMLElement implements OnInit {
	private _currentRegionSubscription

	constructor() {
		super()
	}

	onInit() {
		const initialRegion = localStorage.getItem('gmwp.region_select_cookie')
			? JSON.parse(localStorage.getItem('gmwp.region_select_cookie')).regionCode
			: 'default'

		if (window.gbpe?.regionService?.currentRegion$) {
			this._currentRegionSubscription = window.gbpe.regionService.currentRegion$.subscribe(region =>
				this._replaceRegionSpecificTextContent(region.code)
			)
		} else {
			this._replaceRegionSpecificTextContent(initialRegion)
		}

		if (!this._currentRegionSubscription) {
			this._addEventListeners()
		}
	}

	/**
	 * Method called when the element is removed from the DOM.  Need to remove event handlers.
	 */
	disconnectedCallback() {
		if (this._currentRegionSubscription) this._currentRegionSubscription.unsubscribe()
		this._removeEventListeners()
	}

	private _addEventListeners() {
		document.addEventListener('gbds-selectable-list-event', () => {
			this._currentRegionSubscription = window.gbpe.regionService.currentRegion$.subscribe(region =>
				this._replaceRegionSpecificTextContent(region.code)
			)
		})
	}

	/**
	 * Updates the price when the region is changed.
	 * @param region - currently selected region.
	 */
	private _replaceRegionSpecificTextContent(region: string) {
		const regionPriceAttribue = region.toLowerCase() + '-price'
		this._hasRegionPriceAttribute(regionPriceAttribue)
			? (this.textContent = this.getAttribute(regionPriceAttribue))
			: (this.textContent = this.getAttribute('default-price'))
		this.classList.remove('hide')
	}

	private _hasRegionPriceAttribute(regionPriceAttr: string) {
		return this.hasAttribute(regionPriceAttr)
	}

	private _removeEventListeners() {
		document.removeEventListener('gbds-selectable-list-event', () => {
			this._currentRegionSubscription = window.gbpe.regionService.currentRegion$.subscribe(region =>
				this._replaceRegionSpecificTextContent(region.code)
			)
		})
	}
}
